import { render, staticRenderFns } from "./DepPlasticSurgery.vue?vue&type=template&id=1ebd6adc&scoped=true&"
import script from "./DepPlasticSurgery.vue?vue&type=script&lang=js&"
export * from "./DepPlasticSurgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd6adc",
  null
  
)

export default component.exports